import { APP_STORAGE_NAMESPACE } from '../utils/storageNames'

// A local opt-in is never authorization. App combines this with a fresh, account-bound admin verdict.
export const contextsPreferenceKey = (owner: string) => `${APP_STORAGE_NAMESPACE}:dev-contexts:v1:${owner}`

export function readContextsPreference(owner: string | null): boolean {
  if (!owner) return false
  try { return localStorage.getItem(contextsPreferenceKey(owner)) === 'true' }
  catch { return false }
}

export function writeContextsPreference(owner: string, enabled: boolean): void {
  localStorage.setItem(contextsPreferenceKey(owner), String(enabled))
}
